import momentGenerateConfig from 'rc-picker/lib/generate/moment'

import generatePicker from 'antd/lib/date-picker/generatePicker'
import {Moment} from 'moment'
import './date-picker.scss'

const DatePicker = generatePicker<Moment>(momentGenerateConfig)

export default DatePicker
